import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量通过");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("审核");

import { ref } from 'vue';
import { getVexTableProps, dateFormat } from '@/config';
import { getSurveyApplyList, getAreaListData, getCommonCustomList, auditSurveyApply, batchAuditPass } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import AuditAurveyInfoModal from './component/AuditAurveyInfoModal.vue';
export default {
  name: 'GeneralSurveyApply',

  setup(__props) {
    const sourceText = {
      '0': '在线开户',
      '1': '流向数据',
      '2': '客户拜访',
      '3': 'ERP客户注册'
    };
    const form = ref({
      custName: '',
      custTypeName: '',
      custProvinceCode: '',
      custCityCode: '',
      custDistrictCode: '',
      custType: '',
      begin: '',
      status: '',
      end: '',
      source: '',
      cusArea: null
    });
    const currentData = ref(null); // 客户类型列表

    const custTypeList = ref([]); // 地区级联数据

    const areaTreeData = ref();
    const showEditInfoModal = ref(false);
    const table = ref();

    function reset() {
      form.value = {
        custName: '',
        custTypeName: '',
        custProvinceCode: '',
        custCityCode: '',
        custDistrictCode: '',
        custType: '',
        begin: '',
        status: '',
        end: '',
        source: '',
        cusArea: null
      };
      table.value.commitProxy('reload');
    }

    function recursionTree(tree, parent) {
      tree.forEach(i => {
        i.parent = parent ? {
          areaLevel: parent.areaLevel,
          id: parent.id,
          text: parent.text,
          parent: parent.parent
        } : null;

        if (i.children && i.children.length > 1) {
          recursionTree(i.children, i);
        }
      });
      return tree;
    } // 获取地区数据


    getAreaListData().then(data => {
      if (data.code === 1) {
        areaTreeData.value = recursionTree(data.data.treeList, null);
      }
    }); // 获取客户类型

    getCommonCustomList().then(data => {
      if (data.rows) {
        custTypeList.value = data.rows;
      }
    });

    function selectAreaTree(e) {
      form.value = _objectSpread(_objectSpread({}, form.value), {}, {
        custProvinceCode: '',
        custCityCode: '',
        custDistrictCode: ''
      });
      const areaLevel = e.areaLevel.replace(/^[a-z]/, i => i.toLocaleUpperCase());
      form.value['cust' + areaLevel + 'Code'] = e.id;
    }

    function audit(row) {
      let current = {};
      Object.keys(row).forEach(key => {
        current[key] = row[key] === '——' ? '' : row[key];
      });
      currentData.value = current;
      showEditInfoModal.value = true;
    }

    function auditConfirm(formData) {
      auditSurveyApply(_objectSpread(_objectSpread({}, formData), {}, {
        __repeat: true,
        __warn: true
      })).then(data => {
        if (data.success) {
          showEditInfoModal.value = false;
          ElMessage.success('操作成功!');
          table.value.commitProxy('query');
        }
      });
    } // 批量审核


    function batchAudit() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否批量通过${selectRows.length}条信息`).then(() => {
        batchAuditPass({}, {
          params: {
            __repeat: true,
            __warn: true,
            ids: selectRows.map(i => i.id).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success(`操作成功!  成功${data.data.success}条数据,  失败${data.data.fail}条数据!`);
            table.value.commitProxy('query');
          }
        });
      });
    }

    const tableOptions = getVexTableProps({
      exportConfig: {
        type: 'html/xlsx'
      },
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return row.status === 2;
        }

      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'custName',
        title: '客户名称',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custTypeName',
        title: '客户类型',
        width: '150px',
        showOverflow: true
      }, {
        field: 'custArea',
        title: '客户区域',
        width: '200px',
        showOverflow: true
      }, {
        field: 'address',
        title: '客户地址',
        width: '300px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '联系人',
        width: '150px',
        showOverflow: true
      }, {
        field: 'linkPhone',
        title: '联系电话',
        width: '200px',
        showOverflow: true
      }, {
        field: 'statusText',
        title: '审核状态',
        width: '150px',
        showOverflow: true
      }, {
        field: 'createAt',
        title: '申请时间',
        width: '200px',
        showOverflow: true
      }, {
        field: 'source',
        title: '数据来源',
        width: '150px',
        showOverflow: true,
        slots: {
          default: 'source'
        }
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '200px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSurveyApplyList(_objectSpread({
              page: page.currentPage,
              size: page.pageSize
            }, form.value)).then(data => {
              if (data.success) {
                const auditStatusObj = {
                  0: '未通过',
                  1: '已通过',
                  2: '待审核'
                };
                const sourceObj = {
                  0: 'App',
                  1: '流向数据'
                };
                data.data.records.forEach(item => {
                  item.custArea = '';
                  item.custArea += item.custProvinceName || '';
                  item.custArea += item.custCityName || '';
                  item.custArea += item.custAreaName || '';
                  item.statusText = auditStatusObj[item.status] || '——';
                  Object.keys(item).forEach(key => {
                    if (key == 'source') return;
                    item[key] = item[key] || '——';
                  });
                });
                res({
                  total: data.data.total,
                  result: data.data.records
                });
              }
            });
          })
        }
      }
    });

    function refreshHandle() {
      showEditInfoModal.value = false;
      table.value.commitProxy('query');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_tree_select = _resolveComponent("el-tree-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref: "formRef"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "custName",
              label: "客户名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.custName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.custName = $event),
                modelModifiers: {
                  trim: true
                },
                placeholder: "请输入客户名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "custType",
              label: "客户类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.custType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.custType = $event),
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ''
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(custTypeList.value, type => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: type.dictitemName,
                    value: type.dictitemCode,
                    key: type.dictitemCode
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "linkMan",
              label: "客户区域"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                modelValue: form.value.cusArea,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.cusArea = $event),
                data: areaTreeData.value,
                label: "text",
                "node-key": "id",
                filterable: "",
                accordion: "",
                props: {
                  label: 'text'
                },
                onNodeClick: selectAreaTree,
                "check-strictly": true
              }, null, 8, ["modelValue", "data"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.begin,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.begin = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.end,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.end = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "status",
              label: "审核状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.status = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ''
                }), _createVNode(_component_el_option, {
                  label: "未通过",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "已通过",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "待审核",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "source",
              label: "数据来源"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.source,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.source = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ''
                }), _createVNode(_component_el_option, {
                  label: "在线开户",
                  value: "0"
                }), _createVNode(_component_el_option, {
                  label: "流向数据",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "客户拜访",
                  value: "2"
                }), _createVNode(_component_el_option, {
                  label: "ERP客户注册",
                  value: "3"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[7] || (_cache[7] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          icon: "Stamp",
          onClick: batchAudit
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_alert, {
          style: {
            "margin-left": "20px",
            "width": "auto",
            "padding-right": "30px"
          },
          title: "注意: 审核时请确保客户信息无误, 建议每周至少审核一次! ",
          type: "error"
        })])]),
        operation: _withCtx(({
          row
        }) => [row.status === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Edit",
          onClick: $event => audit(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        source: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(sourceText[String(row.source)]), 1)]),
        _: 1
      }, 16), _createVNode(AuditAurveyInfoModal, {
        modelValue: showEditInfoModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showEditInfoModal.value = $event),
        areaTreeData: areaTreeData.value,
        custTypeList: custTypeList.value,
        currentData: currentData.value,
        onSuccess: auditConfirm,
        onRefresh: refreshHandle
      }, null, 8, ["modelValue", "areaTreeData", "custTypeList", "currentData"])]);
    };
  }

};